import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";  

export default function PrivacyPolicy() {
  return (
    <>
      <SEO  
        title="Privacy Policy - Data Protection | EnteliPro AI ERP & CRM"
        description="Read EnteliPro's Privacy Policy to understand how we collect, use, and protect your personal information. Your data security is our priority."
        keywords="Privacy Policy, Data Protection, Privacy Statement, Personal Information Security, GDPR Compliance, EnteliPro Privacy"
        canonical="https://www.entelipro.com/privacypolicy"
        ogImage="https://www.entelipro.com/static/media/logo512.png"
      />

      <Navbar />

      {/* Hidden H1 for SEO - visible to search engines but hidden visually */}  
      <h1 className="visually-hidden">Privacy Policy - EnteliPro AI ERP & CRM Data Protection</h1>  

      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Privacy Policy</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>A. Introduction</h3>
              <p className="para">
                This Policy details our commitment to protecting the privacy of
                individuals who:
                <br />
                <br />
                A. visit our Websites (defined below) or individuals who request
                us to contact them via our online web forms
                <br />
                <br />
                B. who register to use the products and services which we market
                for subscription available at www.insaccrm.com; or
                <br />
                <br />
                C. attend or register to attend webinars, sponsored events, or
                other events at which the {`${project_name}`} participates.
              </p>
              <br />

              <p className="para">
                For this Policy, the term Websites shall refer collectively to
                www.entelipro.com as well as the other websites that the{" "}
                {`${project_name}`} that you provide. It also describes your
                choices regarding the use, access, and correction of your
                personal information.
              </p>
              <br />
              <br />

              <h3>B. Information That You Provide To Us</h3>
              <p className="para">
                Account and Registration Information:
                <br />
                We ask for and may collect personal information about you such
                as your name, address, phone number, email address, instant
                messaging ID, and credit card information, as well as certain
                related information like your company name and website name,
                when you register for an account to access or utilize one or
                more of our Services. We also ask for and collect personal
                information such as an email address and a name or alias from
                any individual that you authorize to log into and utilize our
                Services in connection with Your Account. We base the processing
                of your personal information on our legitimate interest, to
                provide you with the necessary functionality during your use of
                our Service.
              </p>
              <br />

              <p className="para">
                If you sign-up for a free trial Account, you are not required to
                enter your credit card information unless and until you decide
                to continue with a paid subscription to our Services. A
                third-party intermediary is used to manage credit card
                processing. This intermediary is not permitted to store, retain,
                or use your billing information for any purpose except for
                credit card processing on our behalf.
              </p>
              <br />

              <p className="para">
                We refer to any information described above as Account
                Information for this Policy. By voluntarily providing us with
                Account Information, you represent that you are the owner of
                such personal information or otherwise have the requisite
                consent to provide it to us.
              </p>
              <br />

              <p className="para">
                Other Submissions:
                <br />
                We ask for and may collect personal information from you when
                you submit web forms on our Websites or as you use interactive
                features of the Websites, including participation in webinars,
                surveys, contests, promotions, sweepstakes, requesting customer
                support, or otherwise communicating with us. We process your
                personal information to perform our contract with you for the
                use of our websites and the Service(s) and to fulfill our
                obligations under the Service Agreement to you; where we have
                not entered into the Service Agreement with you, we base the
                processing of your personal information on our legitimate
                interest to operate and administer our websites and to provide
                you with the content you access and request.
              </p>
              <br />

              <p className="para">
                Attendee Information:
                <br />
                We ask for and may collect personal information such as your
                name, address, phone number, and email address when you register
                for or attend a sponsored event or other events at which any
                member of the Zendesk Group participates, to facilitate your
                registration or attendance at an event, including sending
                related communications to you.
              </p>
              <br />

              <p className="para">
                Mobile Application:
                <br />
                When you or your Agents download and use our Services, we
                automatically collect information such as the type of device you
                use, the operating system version of the device, the cellular
                carrier facilitating connection to the mobile application, and
                the country the connection is arising from, to perform our
                obligations under our Master Subscription Agreement with our
                Subscribers.
              </p>
              <br />

              <br />
              <br />

              <h3>C. Information That We Collect From You on our Websites</h3>
              <p className="para">
                Cookies and Other Tracking Technologies:
                <br />
                We and our authorized partners may use cookies and other
                information-gathering technologies for a variety of purposes.
                These technologies may provide us with personal information,
                information about devices and networks you utilize to access our
                Websites, and other information regarding your interactions with
                our Websites. For detailed information about the use of cookies
                on our Websites and how to manage your cookie settings, please
                read and review our Cookie Policy found here.
              </p>
              <br />
              <p className="para">
                We may use web beacons, tags, and scripts on our Websites or in
                email or other electronic communications we send to you. These
                assist us in delivering cookies, counting visits to our
                Websites, understanding usage and campaign effectiveness, and
                determining whether an email has been opened and acted upon. We
                may receive reports based on the use of these technologies by
                our third-party service providers on an individual and
                aggregated basis.
              </p>
              <br />

              <p className="para">
                Logs:
                <br />
                As is true with most websites and services delivered over the
                Internet, we gather certain information and store it in log
                files when you interact with our Websites and Services. This
                information includes internet protocol (IP) addresses as well as
                browser type, internet service provider, URLs of referring/exit
                pages, operating system, date/time stamp, the information you
                search for, locale and language preferences, identification
                numbers associated with your devices, your mobile carrier, and
                system configuration information. Occasionally, we connect
                personal information to information gathered in our log files as
                necessary to improve our Websites and Services. In such a case,
                we would treat the combined information by this Policy.
              </p>
              <br />

              <p className="para">
                Analytics:
                <br />
                We collect analytics information when you use the Websites to
                help us improve them, including through the use of cookies. We
                may also share aggregated and/or anonymized data about your
                actions on our Websites with third-party service providers of
                analytics services. We also use mobile analytics software to
                allow us to better understand the functionality of our mobile
                versions of our Services on your mobile device. This software
                may record information such as how often you use the
                application, the events that occur within the application,
                aggregated usage, performance data, and where the application
                was downloaded from. We do not link the information we store
                within the analytics software to any personally identifiable
                information you submit within the mobile application.
              </p>
              <br />

              <h3>D. Information Collected From Other Sources</h3>
              <p className="para">
                Social Media Widgets:
                <br />
                The Websites include social media features, such as the Facebook
                Like button, and widgets, such as the Share This button or
                interactive mini-programs that run on our Websites. These
                features may collect your Internet protocol address, which page
                you are visiting on the Websites, and may set a cookie to enable
                the feature to function properly. Social media features and
                widgets are either hosted by a third party or hosted directly on
                the Websites. Your interactions with these features are governed
                by the privacy statement of the companies that provide them.
                <br />
                Information From Services Provided by Third Parties:
              </p>
              <br />
              <p className="para">
                We may also obtain other information, including personal
                information, from third parties and combine that with
                information we collect through our Websites. For example, we may
                have access to certain information from a third-party social
                media or authentication service if you log into our Services
                through such a service or otherwise provide us with access to
                information from the service. Any access that we may have to
                such information from a third-party social media or
                authentication service is by the authorization procedures
                determined by that service. If you authorize us to connect with
                a third-party service, we will access and store your name, email
                address(es), current city, profile picture URL, and any other
                personal information that the third-party service makes
                available to us, and use and disclose it following this Policy.
                You should check your privacy settings on these third-party
                services to understand and change the information sent to us
                through these services. For example, you may choose to log in to
                the Services using single sign-in services such as Facebook
                Connect or an Open ID provider.
              </p>
              <br />

              <p className="para">
                These single sign-on services will authenticate your identity,
                provide you with the option to share certain personal
                information (such as your name and email address) with us, and
                pre-populate our sign-up form. Services like Facebook Connect
                give you the option to post information about your activities in
                the Services to your profile page to share with others within
                your network.
              </p>
              <br />
              <br />

              <h3>E. Other Important Privacy Information</h3>
              <p className="para">
                Notice to End-Users
                <br />
                Our Services are intended for use by enterprises. Where our
                Services are made available to you through a Subscriber of ours,
                that enterprise is the data controller of your personal
                information. Your data privacy questions and requests should
                initially be submitted to the {`${project_name}`} Subscriber in
                its capacity as your data controller. {`${project_name}`} is not
                responsible for our Subscriber's privacy or security practices
                which may be different than this Policy.
                {`${project_name}`} Subscribers can:
                <br />
                restrict, suspend or terminate your access to the Services;
                <br />
                access and describe your personal information that you provided
                to them;
                <br />
                access and export your personal information processed by them;
                and
                <br />
                amend your personal information, including your end-user
                profile.
              </p>
              <br />
              <p className="para">
                Data retention
                <br />
                Where {`${project_name}`} is the data controller of personal
                information (for example, personal information relating to
                Website Visitors, Attendees, and individuals who register to use
                our Services), then we retain the personal information we
                collect where we have an ongoing legitimate business need to do
                so (for example, to provide you with our Services, to enable
                your participation in an event, and to comply with applicable
                legal, tax or accounting requirements). When we have no ongoing
                legitimate business need to process your personal information,
                we will either delete or aggregate it or, if this is not
                possible (for example, because your personal information has
                been stored in backup archives), then we will securely store
                your personal information and isolate it from any further
                processing until deletion is possible.
                <br />
                If your personal information is processed within a Subscribers
                Service Data, we will process the personal information for as
                long as we are instructed to do so by the relevant Subscriber
                that is the data controller of the Subscriber Service Data.
              </p>
              <br />
              <br />

              <h3>F. Who do we share Personal Data with?</h3>
              <p className="para">
                We may share Personal Data with various parties, including:
                <br />
                1. Our contracted service providers that process Personal Data
                on our behalf for IT and system administration and hosting,
                credit card processing, research and analytics, marketing,
                customer support, and data enrichment;
                <br />
                2. Affiliates within our current or future corporate group that
                process Personal Data for customer support, marketing, event
                management, technical operations, and account management;
                <br />
                3. If you are using our services as an authorized user, with the{" "}
                {`${project_name}`} customer responsible for your access to the
                services for verifying your account, investigating suspicious
                activity, and reviewing compliance with our usage terms and
                policies;
                <br />
                4. Sponsors of events, webinars, or contests for which you
                register;
                <br />
                5. Third-party social media and advertising networks, which
                usually act as separate controllers, so that we can advertise on
                their platforms;
                <br />
                6. Specifically about our AppExchange website, with our
                third-party partners who may contact you regarding their
                products or services;
                <br />
                7. In individual instances, professional advisers who provide
                consultancy, banking, legal, insurance, and accounting services,
                or if we are involved in a merger, reorganization, asset sale,
                or business combination; and
                <br />
                8. Public and government authorities, to the extent we are
                compelled to disclose Personal Data to comply with our legal
                obligations.
              </p>
              <br />
              <br />

              <h3>G. Your rights relating to your Personal Data</h3>
              <p className="para">
                You have certain rights relating to your Personal Data, subject
                to local data protection laws. These rights may include:
                <br />
                1. To access your Data held by us (right to access);
                <br />
                2. To rectify inaccurate Personal Data and, taking into account
                the purpose of processing the Personal Data, ensure it is
                complete (right to rectification
                <br />
                3. To erase/delete your Personal Data, to the extent permitted
                by applicable data protection laws (right to erasure; right to
                be forgotten);
                <br />
                4. To restrict our processing of your Data to the extent
                permitted by law (right to restriction of processing);
                <br />
                5. To transfer your Data to another controller, to the extent
                possible (right to data portability);
                <br />
                6. To object to any processing of your Personal Data carried out
                based on our legitimate interests (right to object). Where we
                process your Personal Data for direct marketing purposes or
                share it with third parties for their direct marketing purposes,
                you can exercise your right to object at any time to such
                processing without having to provide any specific reason for
                such objection;
                <br />
                7. To not be subject to a decision based solely on automated
                processing, including profiling, which produces legal effects
                ("Automated Decision-Making"); Automated Decision-Making
                currently does not take place on our websites or in our
                services; and
                <br />
                8. To the extent we base the collection, processing, and sharing
                of your Personal Data on your consent, to withdraw your consent
                at any time, without affecting the lawfulness of the processing
                based on such consent before its withdrawal.
                <br />
              </p>
              <br />
              <br />

              <h3>H. Responsible {`${project_name}`} Entity</h3>
              <p className="para">
                {`${project_name}`} is the controller of your Personal Data and
                is responsible for its processing unless expressly specified
                otherwise in our full Privacy Statement. For the avoidance of
                doubt, our Privacy Statement does not apply to the extent we
                process Personal Data in the role of a processor on behalf of
                our customers. A reference to {`${project_name}`}, we, us, or
                the Company is a reference to entelipro.com, inc and the
                relevant affiliate involved in the processing activity. The
                office locations of where entelipro.com, inc. and its affiliates
                are located can be found here. Please see the "Contacting us"
                section, below, for our contact information and the contact
                information of our data protection officer.
              </p>
              <br />
              <br />

              <h3>I. Data Protection Officer</h3>
              <p className="para">
                If you have any questions about this Privacy Policy, or if you
                have a disability and need to access this notice in a different
                format, please contact us here or by mail at:
                <br />
                <br />
                support@entelipro.com
                <br />
                info@entelipro.com
                <br />
                <br />
                www.entelipro.com
                <br />
                <br />
                373, Aswath Nagar, Bengaluru,
                <br /> 2nd Main Road, Marathahalli,
                <br /> Bangalore - 560037, Near Annapoorna Theatre
              </p>
              <br />
              <br />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}